export const ROLES = ["admin", "manager", "leader", "sr_engineer", "jr_engineer", "drafter", "qa1", "qa2", "final_qc", "hr_manager", "office_assistant"];
export const TEAM_ROLES = ["admin", "manager", "lead", "employee"];
export const DESIGNATIONS = [
  "Team Manager",
  "Team Leader",
  "Sr. Engg. (CAD Technican)",
  "Jr. Engg. (CAD Technican)",
  "Trainee (CAD Technican)",
  "HRA",
  "OfficeBoy",
];
export const DEPARTMENTS = [
  "Admin",
  "Land Surveying & Development",
  "Civil Engg.",
  "Architectural",
  "BIM | Steel | Mechanical",
  "IT & Technology",
];

// Flatten hierarchy tree into [{node, depth}] so we can render without recursive JSX.
